<template>
  <div>
    <v-btn
      v-if="detailItem.length < parseInt(parentObject.cycledays)"
      color="primary"
      dark
      class="mt-4 mb-2 ml-1"
      @click="openNewItem"
    >+</v-btn>

    <v-dialog v-model="patterndDialog" max-width="600px">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title>
          <span class="headline mb-4">{{ $t('setuppattern.patterndetailitem') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="6" sm="6" class="pb-n5">
                  <v-text-field
                    outlined
                    :label="$t('setuppattern.sequenceno')"
                    type="number"
                    ref="sequenceno"
                    :rules="[rules.required]"
                    v-model="selections[0].sequenceno"
                    dense
                    :readonly="isExisting"
                    :background-color="isExisting ? '#ffeab2' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="10" sm="10" class="pb-n5 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="$t('setuppattern.shift')"
                    ref="shiftid"
                    dense
                    clearable
                    :items="shiftList"
                    v-model="selections[0].shiftid"
                    @change="changeShiftHandler(selections[0].shiftid)"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" sm="6" class="pb-n5 mt-n8">
                  <v-text-field
                    outlined
                    :label="$t('setuppattern.shiftdesc')"
                    type="text"
                    v-model="selections[0].shiftdesc"
                    dense
                    readonly
                    background-color="#ffeab2"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="10" sm="10" class="pb-n5 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="$t('setuppattern.daytype')"
                    ref="daytypeid"
                    dense
                    clearable
                    :items="daytypeList"
                    :rules="[rules.required]"
                    v-model="selections[0].daytypeid"
                    @change="changeDaytypeHandler(selections[0].daytypeid)"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-text v-if="isErr" class="mt-n12">
          <span style="font-weight: bold; color: red">{{ errMsg }}</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="closeDialog">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="green darken-1" text @click="saveItem">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="mt-2" style="overflow-x: auto; width: 100%;">
      <v-data-table
        :headers="this.parentObject.tabHeader"
        :items="detailItem"
        class="elavation-1"
        :sort-by="['sequenceno']"
        :item-class="rowClass"
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="modifyItemHandler(item)">mdi-pen</v-icon>
          <v-icon small class="ml-3 mr-2" @click="deleteItemHandler(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parentObject: Object,
  },

  data() {
    return {
      rules: {
        required: value => !!value || this.$t('reportsparam.required'),
      },
      patterndDialog: false,
      detailItem: this.parentObject.detailItem,
      selections: [{
        id: null,
        patternid: null,
        sequenceno: null,
        shiftid: null,
        shiftcode: null,
        shiftdesc: null,
        daytypeid: null,
        daytypecode: null,
        daytypedesc: null,
        stamp: 0,
        action: 0,
      }],
      shiftItems: [],
      shiftList: [],
      daytypeItems: [],
      daytypeList: [],
      modify: false,
      isExisting: false,
      isErr: false,
      errMsg: "",
    };
  },

  methods: {
    openNewItem() {
      this.newItem();
      this.patterndDialog = true;
    },

    newItem() {
      this.isExisting = false;
      this.modify = false;
      this.resetSelections();

      const maxSeq = this.detailItem.length > 0
        ? Math.max(...this.detailItem.map(d => d.sequenceno || 0))
        : 0;
      this.selections[0].sequenceno = maxSeq + 1;
    },

    loadShifts() {
      const vm = this;
      this.$store.dispatch("get", { url: "/shiftsetup/all" })
        .then(res => {
          vm.shiftItems = res.data.rec;
          for (let i = 0; i < vm.shiftItems.length; i++) {
            vm.shiftList.push({
              text: vm.shiftItems[i].shiftcode + " - " + vm.shiftItems[i].shiftdesc,
              value: vm.shiftItems[i].id,
            });
          }
        })
        .catch(err => { vm.errMsg = err; });
    },

    loadDaytypes() {
      const vm = this;
      this.$store.dispatch("get", { url: "/daytype/all" })
        .then(res => {
          vm.daytypeItems = res.data.rec;
          for (let i = 0; i < vm.daytypeItems.length; i++) {
            vm.daytypeList.push({
              text: vm.daytypeItems[i].daytypecode + " - " + vm.daytypeItems[i].daytypedesc,
              value: vm.daytypeItems[i].id,
            });
          }
        })
        .catch(err => { vm.errMsg = err; });
    },

    changeShiftHandler(id) {
      if (!id) {
        this.selections[0].shiftcode = null;
        this.selections[0].shiftdesc = null;
        return;
      }
      const item = this.shiftItems.find(s => s.id == id);
      if (item) {
        this.selections[0].shiftcode = item.shiftcode;
        this.selections[0].shiftdesc = item.shiftdesc;
      }
    },

    changeDaytypeHandler(id) {
      if (!id) {
        this.selections[0].daytypecode = null;
        this.selections[0].daytypedesc = null;
        return;
      }
      const item = this.daytypeItems.find(d => d.id == id);
      if (item) {
        this.selections[0].daytypecode = item.daytypecode;
        this.selections[0].daytypedesc = item.daytypedesc;
      }
    },

    modifyItemHandler(item) {
      if (item.action == 1) {
        this.modify = true;
      }
      if (item.action == 2) {
        this.isExisting = true;
      }
      this.selections = [Object.assign({}, item)];
      this.patterndDialog = true;
    },

    deleteItemHandler(item) {
      const vm = this;
      const index = this.detailItem.indexOf(item);

      if (item.action == 2 && item.id) {
        this.$store.dispatch("delete", {
          url: "/patternd/" + item.id + "/" + vm.parentObject.userid,
        })
          .then(res => {
            if (res.data.error) {
              vm.isErr = true;
              vm.errMsg = res.data.error;
            } else {
              vm.detailItem.splice(index, 1);
              vm.$emit("input", vm.detailItem);
            }
          })
          .catch(err => {
            vm.isErr = true;
            vm.errMsg = err;
          });
      } else {
        this.detailItem.splice(index, 1);
        this.$emit("input", this.detailItem);
      }
    },

    closeDialog() {
      this.patterndDialog = false;
      this.isErr = false;
      this.isExisting = false;
      this.modify = false;
      this.resetSelections();
    },

    saveItem() {
      const vm = this;

      if (!this.$refs.form.validate()) return;

      this.isErr = false;

      const payload = {
        patternid: vm.parentObject.patternid,
        sequenceno: vm.selections[0].sequenceno,
        shiftid: vm.selections[0].shiftid,
        daytypeid: vm.selections[0].daytypeid,
        stamp: vm.selections[0].stamp || 0,
        userid: vm.parentObject.userid,
      };

      if (this.isExisting) {
        this.$store.dispatch("put", {
          url: "/patternd/" + vm.selections[0].id,
          payload: payload,
        })
          .then(res => {
            if (res.data.error) {
              vm.isErr = true;
              vm.errMsg = res.data.error;
            } else {
              const index = vm.detailItem.findIndex(d => d.id == vm.selections[0].id);
              if (index > -1) {
                vm.detailItem.splice(index, 1, Object.assign({}, vm.selections[0], { stamp: (vm.selections[0].stamp || 0) + 1 }));
              }
              vm.$emit("input", vm.detailItem);
              vm.patterndDialog = false;
              vm.resetSelections();
            }
          })
          .catch(err => {
            vm.isErr = true;
            vm.errMsg = err;
          });
      } else {
        this.$store.dispatch("post", {
          url: "/patternd/create",
          payload: payload,
        })
          .then(res => {
            if (res.data.error) {
              vm.isErr = true;
              vm.errMsg = res.data.error;
            } else {
              const newRow = Object.assign({}, vm.selections[0], {
                id: res.data.id,
                patternid: vm.parentObject.patternid,
                action: 2,
                stamp: 0,
              });
              vm.detailItem.push(newRow);
              vm.$emit("input", vm.detailItem);
              vm.patterndDialog = false;
              vm.resetSelections();
            }
          })
          .catch(err => {
            vm.isErr = true;
            vm.errMsg = err;
          });
      }
    },

    rowClass(item) {
      return (!item.shiftid || !item.daytypeid) ? 'row-incomplete' : '';
    },

    resetSelections() {
      this.selections = [{
        id: null,
        patternid: null,
        sequenceno: null,
        shiftid: null,
        shiftcode: null,
        shiftdesc: null,
        daytypeid: null,
        daytypecode: null,
        daytypedesc: null,
        stamp: 0,
        action: 0,
      }];
    },
  },

  created() {
    this.loadShifts();
    this.loadDaytypes();
  },
};
</script>

<style scoped>
::v-deep .row-incomplete {
  background-color: #ffebee;
}
::v-deep .row-incomplete td {
  color: #c62828 !important;
}
</style>
